var FAQ, FAQAppRouter, FAQMainView, FAQViewManagerView, SharedFooterUSMainView, SharedUtilsHelper;

FAQMainView = require('./views/main');

FAQViewManagerView = require('./views/viewmanager');

FAQAppRouter = require('./Approuter');

SharedUtilsHelper = require('../../shared/frontend/helpers/utils');

SharedFooterUSMainView = require('../../shared/frontend/views/footer/US/main_view');

Date.now = Date.now || function() {
  return +(new Date);
};

if (!(typeof String.prototype.trim === 'function')) {
  String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

FAQ = {
  createFaqNameSpace: function() {
    var base;
    if (window.Groupon == null) {
      window.Groupon = {};
    }
    if ((base = window.Groupon).FAQ == null) {
      base.FAQ = {};
    }
    return _.extend(window, SharedUtilsHelper);
  }
};

$(document).ready(function() {
  var footer, ref;
  FAQ.createFaqNameSpace();
  if (checkIfIsUSByCountry((ref = window.country) != null ? ref.name : void 0)) {
    footer = new SharedFooterUSMainView();
    footer.render();
    $("#footer-content").html(footer.el);
    toggleCallUs(0);
  }
  if (isCMSEnabled()) {
    Groupon.FAQ.ViewManager = new FAQViewManagerView();
    Groupon.FAQ.Router = new FAQAppRouter();
    if (!Backbone.History.started) {
      Backbone.history.start({
        root: window.FAQBASEURL
      });
    }
  }
  $('.help-wizard-menu').on('click', function() {
    if (isCostcoRelatedFAQ()) {
      window.location.href = window.SUPPORTBASEURL + "?fromFaq=true&fromCostcoFaq=true";
      return false;
    }
    window.location.href = window.SUPPORTBASEURL + "?fromFaq=true";
    return false;
  });
  $('.faqs-menu').on('click', function() {
    redirectToFaq();
    return false;
  });
  $('.ls-faq-link').on('click', function() {
    window.location.href = window.FAQBASEURL + "#welcometothenewlivingsocial";
    location.reload();
    return false;
  });
  return Groupon.Performance.pageReady();
});

//# sourceMappingURL=data:application/json;base64,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
